export const NEWS_API_PATH = {
  detail: '/api/lcv-news-details',
  category: '/api/lcv-news-categories',
  config: '/api/lcv-news-config',
} as const;

export const NEWS_CONTENT_ROWS_COMPONENTS = {
  textContent: 'news.text-content',
  header: 'news.header',
  singleImage: 'news.single-image',
  images: 'news.images',
  highlighted: 'news.highlighted',
  youtube: 'news.youtube',
} as const;

export const NEWS_PER_PAGE = 6;
export const RELATED_NEWS_PER_PAGE = 6;
